module.exports = __webpack_public_path__ + "static/banner-right-img-1-499819d8d7834dd71b17298731b00801.png";